import { render, staticRenderFns } from "./approvalItemGet.vue?vue&type=template&id=1621c456&scoped=true&"
import script from "./approvalItemGet.vue?vue&type=script&lang=js&"
export * from "./approvalItemGet.vue?vue&type=script&lang=js&"
import style0 from "./approvalItemGet.vue?vue&type=style&index=0&id=1621c456&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1621c456",
  null
  
)

export default component.exports